
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ai5wSVj7nRyuItELdQHkJ_4567iHdDBCFpIn0wc_45QGf_45aIMMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/ai.vue?macro=true";
import { default as clickE_45Md_3PFXbo0ST_jtaAlEoexNoC5EywQOw49YeQ4sdkMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/click.vue?macro=true";
import { default as index1_45ZY82Yi0quOoCDPIoB4fBkZgYehrSrzVTj3ljcofUkMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/index.vue?macro=true";
import { default as legalUeQ_IjDRfs5vyONw9F6lFEviJ4pDifyvb_45EqPMEmhKoMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/legal.vue?macro=true";
import { default as contactwClf__45yQYlOdN5MCfjbg86ZqRWW9YJjg8FlzRDf_45xrkMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/contact.vue?macro=true";
import { default as log46sMXC0hDlYRb3rkPI32auPF1UV7YxFLXhrcCAtUm_IMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/dev/log.vue?macro=true";
import { default as pricingUQpEA7GW6HHKYHjoOHkZwOaEq_zMO7arafUkO0Vim_wMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/pricing.vue?macro=true";
import { default as changelogMozGtMETzHBVYlaYkWbfdqNxPnS1fniIZ6pWYbqznxIMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/changelog.vue?macro=true";
import { default as indexganDJvItV08_Xg4lKAwJzywcwzT51_45mEQdNPNsOjMuYMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/dev/index.vue?macro=true";
import { default as usersBz35PwlpSax5OT2IuvhWn4Eih_45CoaYsDb9klMuqb16YMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/dev/users.vue?macro=true";
import { default as indexajbQPC2_caESb9MvCR2YUAjQMIFbo0FqBtCEu4mpqGAMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/blog/index.vue?macro=true";
import { default as indexoQT3U8ln454j7sc9h4R_45uqUNYzUueVc_wX7b5l6AtgsMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/help/index.vue?macro=true";
import { default as fonts_45JKmsO63AE3qH4eJSqrdzpyqJPG_45lev6_4514lQp4Y2nIMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/user/fonts.vue?macro=true";
import { default as _91slug_93hImmj6ANX__iNWFSXnU10bAz0DOJEQBbWoGfBy5y50oMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/blog/[slug].vue?macro=true";
import { default as imitateKUQ_6rabB6cpzSiFOEMO0AVWSUJvSR_45yvaXXUKZxinkMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/dev/imitate.vue?macro=true";
import { default as _91slug_93YzLf3jV72ifkcYJt8TpOpJw_KYWD45xEPCTDqhJ3QPwMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/help/[slug].vue?macro=true";
import { default as _91slug_93PPfvhOBJgrBKnVQ05baiyXpFUKiaiV_45_f_459vjAxOoGgMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/page/[slug].vue?macro=true";
import { default as signin1Ae6Z7rwuGM8lVyBnxBSIgdmSNtXPjPHEGHoQvr4knwMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/user/signin.vue?macro=true";
import { default as signupT8SW_HU1dbgPlnjKBgpBP7Br5ysRtICMQV8jITkZJTQMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/user/signup.vue?macro=true";
import { default as figma_plugin0gi4x5VbjB9JQ2JM096oW6q6hynkQRAF4yekH_45uRs_gMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/figma_plugin.vue?macro=true";
import { default as accountKTfmJzbNDye6IdlGni_45exQWGg_45e9HT6lN4kyQwg8q_45oMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/user/account.vue?macro=true";
import { default as campaignsPvC_45EMEmbuIrWZ9nxYZgwrWEsR_4BhDeL_45WE3b2I8mMMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/dev/campaigns.vue?macro=true";
import { default as creativessJ2vj2vWgg12hT29TVrI7O8Me4ndF8qVJW4VSiCCWtAMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/dev/creatives.vue?macro=true";
import { default as my_45engineUCHGvkNzArXVCfyzvWjNF7N7S_GSHoGdm3n0lEN9EhYMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/next/my-engine.vue?macro=true";
import { default as magiclinkERsmy9Itnk_QDeJcfzozBvzhL9W7fthmFHXQqHlZDgMMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/user/magiclink.vue?macro=true";
import { default as _91_46_46_46slug_93TJ3XgwTk7kkFssu0t24uopEx0HYnWtupjqm5nS3bKz4Meta } from "/Users/ress/dev/foldwrap/frontend/app/pages/delivery/[...slug].vue?macro=true";
import { default as _91id_93_46clientvdkmF_45PuENscw9EwQgdKOBt606ML_45AT_45lOWCUJgguRcMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/editor/[id].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/Users/ress/dev/foldwrap/frontend/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as colorcontrolsrRKka3jSyZ2dsJjI7AkJxo7U_1_LKc2fuR0VhaXyNMcMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/next/colorcontrols.vue?macro=true";
import { default as _91id_93_46clientdhXF1ODB3SIM0YK80jtSqVxKyYW9WcyCLFYhAAKlDDcMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/review/[id].client.vue?macro=true";
import { default as in_45housem_45agzJJHW5eJ9qY9JD_458qcVKWpNhjG1_45uO06ygosSQcMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/solutions/in-house.vue?macro=true";
import { default as gif_45exports_451x5h5rIVfY1yx7_45xjxhTV8TZ8LiDOEq3E1L_45w3eh4Meta } from "/Users/ress/dev/foldwrap/frontend/app/pages/features/gif-export.vue?macro=true";
import { default as password_resetIcaIHI_XqF0_vFXq7lw_BvsmuCy2YtthBdQ0_45xXARsEMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/user/password_reset.vue?macro=true";
import { default as getting_45started2WIwWSvcbGnQgcr_KwK8AfR7tmwtIG61Fo_4541kVS2cYMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/help/getting-started.vue?macro=true";
import { default as selection_45debugPs69oHEmqfZKW8LucWlhJ60dfKTKYoF1lTgnBBm52poMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/next/selection-debug.vue?macro=true";
import { default as indexZV7ICJcxLgnIMwZqsNkz_fBrWT1BKGVfCKSkXDJ_45ZLwMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/user/campaigns/index.vue?macro=true";
import { default as indexJSeWHaVZtlPsxvgrVszY8Tzb8GS1yHU4LEr_lH3fyKAMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/user/creatives/index.vue?macro=true";
import { default as video_45exportsLeEvJE9Y5qSuKzMbEzKEvCfG8sEdYBdWeDYC3dEn1EMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/features/video-export.vue?macro=true";
import { default as freelancers65hdqJdh4ebNCugMbA84g6sQ7TnAv1DjAOv0NBvcyQsMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/solutions/freelancers.vue?macro=true";
import { default as video_render_tasksAGEYY_45N7MT2dJDlV_Q5JbVBG8AfwByPF1GhYUIaXZI0Meta } from "/Users/ress/dev/foldwrap/frontend/app/pages/dev/video_render_tasks.vue?macro=true";
import { default as _91_46_46_46id_93_3k5S1j6q_45jqhApSik_r9h69nEOUzN4c_45M03qaKfXj0Meta } from "/Users/ress/dev/foldwrap/frontend/app/pages/dev/user_details/[...id].vue?macro=true";
import { default as scale_45with_45datashlwuFtGqqd5ITj3flyHB3ee9APzndfSkSJtbBxIty0Meta } from "/Users/ress/dev/foldwrap/frontend/app/pages/features/scale-with-data.vue?macro=true";
import { default as index_save_may_2025oT1LRh_45k2d3N8Ljkn5dlEHeNRpH3O6YYVSd2RN_Pll4Meta } from "/Users/ress/dev/foldwrap/frontend/app/pages/next/index_save_may_2025.vue?macro=true";
import { default as _91_46_46_46slug_93CbSvS02dp05GCNq11EhHv9BZElaLA9rqAOPmfV4gfT4Meta } from "/Users/ress/dev/foldwrap/frontend/app/pages/user/campaigns/[...slug].vue?macro=true";
import { default as ai_45powered_45editsWCbjb7l0zFQWjQVNfXONDXAx6UeiDANVPyUzWfUbB9MMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/features/ai-powered-edits.vue?macro=true";
import { default as html5_45banner_45adsLpwR4v4IRjmK8eBOEiYjEeuO7MB5tjrNdqIAWRzNYAsMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/features/html5-banner-ads.vue?macro=true";
import { default as digital_45agencieslt2aDqHnpxLPzzLYXOifBaglfHqgeY1yIggN5lOniQYMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/solutions/digital-agencies.vue?macro=true";
import { default as indexxPhZBPVFq2LnJcPhoNmX7htZi3eFLWD14kK7R87mdH0Meta } from "/Users/ress/dev/foldwrap/frontend/app/pages/tools/markdown-slides/index.vue?macro=true";
import { default as automatic_45animationCHhW_KigqgIlYJAu8NS80rTAGEzRnQzuXu6EErtb2MUMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/features/automatic-animation.vue?macro=true";
import { default as side_45by_45side_45review7gkccdhB_jnn2y9IchvGWlk6uzZ2adcHoNYAw000_45MAMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/features/side-by-side-review.vue?macro=true";
import { default as adobe_45animatePSa1EQ3BmbbDVFyk8_kE0zijxfhwgCH58onPlXul7rkMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/alternatives-to/adobe-animate.vue?macro=true";
import { default as ai_45powered_45translationLF1utSzjEDeMBVXbGjiOKgx5qTSm2Q5mIOw1ozeO7JQMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/features/ai-powered-translation.vue?macro=true";
import { default as resize_45banners_45with_45aiFB5rzhQ6dUjpmisdZB6zCFDVw8G5_vRCgZkkW_uukAkMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/features/resize-banners-with-ai.vue?macro=true";
import { default as google_45web_45designerTufBsfKmIwuQGDtLNfvXXYqR5HNktwx01fflx93CPfkMeta } from "/Users/ress/dev/foldwrap/frontend/app/pages/alternatives-to/google-web-designer.vue?macro=true";
import { default as component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta } from "/Users/ress/dev/foldwrap/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ } from "/Users/ress/dev/foldwrap/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "ai",
    path: "/ai",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/ai.vue")
  },
  {
    name: "click",
    path: "/click",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/click.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/legal.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/contact.vue")
  },
  {
    name: "dev-log",
    path: "/dev/log",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/dev/log.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/pricing.vue")
  },
  {
    name: "changelog",
    path: "/changelog",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/changelog.vue")
  },
  {
    name: "dev",
    path: "/dev",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/dev/index.vue")
  },
  {
    name: "dev-users",
    path: "/dev/users",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/dev/users.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/blog/index.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/help/index.vue")
  },
  {
    name: "user-fonts",
    path: "/user/fonts",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/user/fonts.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/blog/[slug].vue")
  },
  {
    name: "dev-imitate",
    path: "/dev/imitate",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/dev/imitate.vue")
  },
  {
    name: "help-slug",
    path: "/help/:slug()",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/help/[slug].vue")
  },
  {
    name: "page-slug",
    path: "/page/:slug()",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/page/[slug].vue")
  },
  {
    name: "user-signin",
    path: "/user/signin",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/user/signin.vue")
  },
  {
    name: "user-signup",
    path: "/user/signup",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/user/signup.vue")
  },
  {
    name: "figma_plugin",
    path: "/figma_plugin",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/figma_plugin.vue")
  },
  {
    name: "user-account",
    path: "/user/account",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/user/account.vue")
  },
  {
    name: "dev-campaigns",
    path: "/dev/campaigns",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/dev/campaigns.vue")
  },
  {
    name: "dev-creatives",
    path: "/dev/creatives",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/dev/creatives.vue")
  },
  {
    name: "next-my-engine",
    path: "/next/my-engine",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/next/my-engine.vue")
  },
  {
    name: "user-magiclink",
    path: "/user/magiclink",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/user/magiclink.vue")
  },
  {
    name: "delivery-slug",
    path: "/delivery/:slug(.*)*",
    meta: _91_46_46_46slug_93TJ3XgwTk7kkFssu0t24uopEx0HYnWtupjqm5nS3bKz4Meta || {},
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/delivery/[...slug].vue")
  },
  {
    name: "editor-id",
    path: "/editor/:id()",
    meta: _91id_93_46clientvdkmF_45PuENscw9EwQgdKOBt606ML_45AT_45lOWCUJgguRcMeta || {},
    component: () => createClientPage(() => import("/Users/ress/dev/foldwrap/frontend/app/pages/editor/[id].client.vue"))
  },
  {
    name: "next-colorcontrols",
    path: "/next/colorcontrols",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/next/colorcontrols.vue")
  },
  {
    name: "review-id",
    path: "/review/:id()",
    meta: _91id_93_46clientdhXF1ODB3SIM0YK80jtSqVxKyYW9WcyCLFYhAAKlDDcMeta || {},
    component: () => createClientPage(() => import("/Users/ress/dev/foldwrap/frontend/app/pages/review/[id].client.vue"))
  },
  {
    name: "solutions-in-house",
    path: "/solutions/in-house",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/solutions/in-house.vue")
  },
  {
    name: "features-gif-export",
    path: "/features/gif-export",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/features/gif-export.vue")
  },
  {
    name: "user-password_reset",
    path: "/user/password_reset",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/user/password_reset.vue")
  },
  {
    name: "help-getting-started",
    path: "/help/getting-started",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/help/getting-started.vue")
  },
  {
    name: "next-selection-debug",
    path: "/next/selection-debug",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/next/selection-debug.vue")
  },
  {
    name: "user-campaigns",
    path: "/user/campaigns",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/user/campaigns/index.vue")
  },
  {
    name: "user-creatives",
    path: "/user/creatives",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/user/creatives/index.vue")
  },
  {
    name: "features-video-export",
    path: "/features/video-export",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/features/video-export.vue")
  },
  {
    name: "solutions-freelancers",
    path: "/solutions/freelancers",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/solutions/freelancers.vue")
  },
  {
    name: "dev-video_render_tasks",
    path: "/dev/video_render_tasks",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/dev/video_render_tasks.vue")
  },
  {
    name: "dev-user_details-id",
    path: "/dev/user_details/:id(.*)*",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/dev/user_details/[...id].vue")
  },
  {
    name: "features-scale-with-data",
    path: "/features/scale-with-data",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/features/scale-with-data.vue")
  },
  {
    name: "next-index_save_may_2025",
    path: "/next/index_save_may_2025",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/next/index_save_may_2025.vue")
  },
  {
    name: "user-campaigns-slug",
    path: "/user/campaigns/:slug(.*)*",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/user/campaigns/[...slug].vue")
  },
  {
    name: "features-ai-powered-edits",
    path: "/features/ai-powered-edits",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/features/ai-powered-edits.vue")
  },
  {
    name: "features-html5-banner-ads",
    path: "/features/html5-banner-ads",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/features/html5-banner-ads.vue")
  },
  {
    name: "solutions-digital-agencies",
    path: "/solutions/digital-agencies",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/solutions/digital-agencies.vue")
  },
  {
    name: "tools-markdown-slides",
    path: "/tools/markdown-slides",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/tools/markdown-slides/index.vue")
  },
  {
    name: "features-automatic-animation",
    path: "/features/automatic-animation",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/features/automatic-animation.vue")
  },
  {
    name: "features-side-by-side-review",
    path: "/features/side-by-side-review",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/features/side-by-side-review.vue")
  },
  {
    name: "alternatives-to-adobe-animate",
    path: "/alternatives-to/adobe-animate",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/alternatives-to/adobe-animate.vue")
  },
  {
    name: "features-ai-powered-translation",
    path: "/features/ai-powered-translation",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/features/ai-powered-translation.vue")
  },
  {
    name: "features-resize-banners-with-ai",
    path: "/features/resize-banners-with-ai",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/features/resize-banners-with-ai.vue")
  },
  {
    name: "alternatives-to-google-web-designer",
    path: "/alternatives-to/google-web-designer",
    component: () => import("/Users/ress/dev/foldwrap/frontend/app/pages/alternatives-to/google-web-designer.vue")
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/banner_production",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/convert_figma",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/delivery",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/page/click-correct",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/docs/:pathMatch(.*)",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/help/introduction",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  }
]